import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';

import FirebaseContext from '../../../../../../context/FirebaseContext';
import { getFallbackIconIds, refreshIconCatalog } from '../habitIcons';
import HabitIconCatalogContext from './HabitIconCatalogContext';

const HabitIconCatalogContextProvider = ({ children }) => {
  const { firebase } = useContext(FirebaseContext);
  const [icons, setIcons] = useState(() => getFallbackIconIds());

  useEffect(() => {
    let isMounted = true;

    setIcons(getFallbackIconIds());

    refreshIconCatalog(firebase)
      .then((catalog) => {
        if (isMounted && catalog?.icons?.length) {
          setIcons(catalog.icons);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [firebase]);

  const value = useMemo(() => ({
    icons,
  }), [icons]);

  return (
    <HabitIconCatalogContext.Provider value={value}>
      {children}
    </HabitIconCatalogContext.Provider>
  );
};

HabitIconCatalogContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HabitIconCatalogContextProvider;
